import React from "react";
import TimerPage from "../../components/TimerPage";

const Stage1: React.FC = () => (
  <TimerPage title="1.立论陈词" initialTime={180} />
);

export default Stage1;
